var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMailİcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.7314 28 28 21.7314 28 14C28 6.26855 21.7314 0 14 0C6.26855 0 0 6.26855 0 14C0 21.7314 6.26855 28 14 28ZM14.4375 9.52702C13.0783 10.1035 10.3644 11.2975 6.29248 13.109C5.63167 13.3757 5.28532 13.64 5.25342 13.8952C5.2124 14.2301 5.5166 14.4079 5.98714 14.5765C6.21387 14.6585 6.47933 14.7383 6.76302 14.8317C7.47624 15.0687 8.43555 15.3467 8.93343 15.3581C9.38574 15.3672 9.89046 15.1758 10.4487 14.7861C14.2518 12.1634 16.216 10.8395 16.339 10.8099C16.4256 10.7894 16.5464 10.7643 16.6284 10.8395C16.7093 10.9124 16.7013 11.0537 16.6934 11.0902C16.6239 11.3932 13.0509 14.7109 12.8447 14.9297C12.7354 15.0459 12.6237 15.1553 12.5166 15.2601C11.8547 15.9118 11.3568 16.4017 12.5439 17.1992C13.1022 17.5752 13.5511 17.8874 13.9966 18.1973C14.5036 18.5505 15.0072 18.8991 15.6611 19.3366C15.8241 19.446 15.9801 19.5599 16.1317 19.6715C16.7104 20.0931 17.2311 20.4714 17.8737 20.4098C18.0275 20.3962 18.1836 20.3278 18.3271 20.1774C18.5322 19.9609 18.7122 19.5781 18.8273 18.9492C19.2899 16.4222 20.2002 10.9512 20.4098 8.69759C20.4281 8.49935 20.4053 8.24642 20.387 8.13477C20.3677 8.02539 20.3289 7.86589 20.1877 7.74967C20.0202 7.61068 19.7627 7.58105 19.6465 7.58333C19.1213 7.59245 18.3158 7.87956 14.4375 9.52702Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMailİcon);
export default __webpack_public_path__ + "static/media/mobile-mail-icon.c68c7132346a0b775483019dd2b35a34.svg";
export { ForwardRef as ReactComponent };